import { EJGameOverState } from "states/ej-game-over-state";
import { BlastworksClientEvent } from "../ClientController";

export class SocialGameOverState extends EJGameOverState {
    public onEnter(cascadeSkip?: boolean): void {
        this.stateMachine.dispatchClientEvent(BlastworksClientEvent.GAME_OVER);
        super.onEnter(cascadeSkip);
    }
}